module.exports = __webpack_public_path__ + "static/media/qurm_villas5.c99f6ca8.webp";